"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Avatar_1 = __importDefault(require("@mui/material/Avatar"));
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var usePixelSize = function (size) {
    switch (size) {
        case 'xs':
            return {
                diameter: 24,
                fontSize: 14,
            };
        case 'sm':
            return {
                diameter: 32,
                fontSize: 16,
            };
        case 'md':
            return {
                diameter: 40,
                fontSize: 18,
            };
        case 'lg':
            return {
                diameter: 72,
                fontSize: 32,
            };
        case 'xl':
            return {
                diameter: 120,
                fontSize: 48,
            };
    }
};
var Avatar = function (_a) {
    var alt = _a.alt, _b = _a.size, size = _b === void 0 ? 'xs' : _b, src = _a.src, style = _a.style, className = _a.className, children = _a.children, props = __rest(_a, ["alt", "size", "src", "style", "className", "children"]);
    var _c = usePixelSize(size), diameter = _c.diameter, fontSize = _c.fontSize;
    return (react_1.default.createElement(Avatar_1.default, __assign({ alt: alt, src: src, className: (0, classnames_1.default)(className, 'fs-exclude'), style: __assign({ width: diameter, height: diameter, fontSize: fontSize }, style) }, props), react_1.default.Children.count(children) > 0
        ? children
        : !src && alt
            ? alt[0]
            : null));
};
exports.default = Avatar;
//# sourceMappingURL=index.js.map